import React, { Fragment } from "react";
import Banner from "./Banner";
import PromotionPopup from "./PromotionPopup";
import Aboutus from "../home-v4/Aboutus";
import Gallery from "./Gallery";
import ContentNoData from "../gallery/ContentNoData";
import Section from "./Section";
import Video from "./Video";
// import Contactmap from "./Contactmap";
// <Contactmap contactInfo={businessInfo} websiteBackgroundColor={websiteBackgroundColor} />


const Content = ({
  businessInfo,
  locationInfo,
  websiteBackgroundColor,
  hideHeaderBackground,
  websiteTextColor,
  videoLink,
}) => {

  const banner_details = businessInfo?.website_manager?.banner_section
  const theme_color = businessInfo?.website_manager?.website_theme_color;
  const aboutUsInfo = businessInfo?.website_manager?.about_us_section
  const galleryInfo = businessInfo?.website_manager?.gallery_section
  const popupinfo = businessInfo?.website_manager?.website_popup_section
  const business_name = businessInfo?.name
  const pathName = window.location.origin

  return (
    <Fragment>
      <PromotionPopup promotionPopUp={popupinfo} businessName={business_name} />
      {!videoLink &&
        <Banner
          bannerInfo={banner_details}
          ThemeColor={theme_color}
          businessName={business_name}
          locationInfo={locationInfo}
          hideHeaderBackground={hideHeaderBackground}
          websiteBackgroundColor={websiteBackgroundColor}
          websiteTextColor={websiteTextColor}
        />
      }
      {videoLink &&
        <Video videoLink={videoLink} businessName={business_name} />
      }
      <Aboutus
        aboutusDetail={aboutUsInfo}
        themeColorDetail={theme_color}
        websiteBackgroundColor={websiteBackgroundColor}
        websiteTextColor={websiteTextColor}
      />
      {(banner_details?.show_secondary_section || banner_details?.show_third_section) && (
        <Section
          websiteBackgroundColor={websiteBackgroundColor}
          customPage={banner_details}
          themeColor={theme_color}
          websiteTextColor={websiteTextColor}
          isHomePage
        />
      )}
      <>
        {galleryInfo !== null && (
          <>
            <Gallery isHome galleryDetail={galleryInfo} gallery_display_count={banner_details?.gallery_display_count} websiteBackgroundColor={websiteBackgroundColor} />
          </>
        )}
        {galleryInfo.length === 0 && (
          <>
            <ContentNoData pathUrl={pathName} websiteBackgroundColor={websiteBackgroundColor} />
          </>
        )}
      </>
    </Fragment>
  );
}


export default Content;
